import axios, {
  AxiosError,
  AxiosHeaders,
  InternalAxiosRequestConfig
} from "axios";

export interface CustomConfig extends InternalAxiosRequestConfig {
  token: string;
}

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_LINX_URL, // Base URL for all requests
  headers: {
    "Content-Type": "application/json"
  },
  // Default params and withCredentials
  // params: {
  //   sessionID: "" // Default sessionID parameter, can be overridden if needed
  // },
  withCredentials: false // Default withCredentials, can be overridden if needed
});

instance.interceptors.request.use(
  (config: CustomConfig) => {
    const token = config.token;

    if (token) {
      config.headers = new AxiosHeaders(config.headers);
      config.headers.set("Authorization", `Bearer ${token}`);
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res?.data;
  },
  async (err: AxiosError) => {
    if (err.response?.status === 403) {
      window.open("https://login.innovationwithin.services/realms/discovery/protocol/openid-connect/auth?client_id=account&redirect_uri=https%3A%2F%2Flogin.innovationwithin.services%2Frealms%2Fdiscovery%2Faccount%2Flogin-redirect&state=0%2F9f083e64-e542-46e8-a4c9-98569909525e&response_type=code&scope=openid");
    }
    return Promise.reject(err);
  }
);

export default instance;
